import { render, staticRenderFns } from "./PlanTermsOfService.vue?vue&type=template&id=1a6752cd&lang=pug&"
import script from "./PlanTermsOfService.vue?vue&type=script&lang=ts&"
export * from "./PlanTermsOfService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports